import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { Eye, CheckCircle, Trash2 } from 'lucide-react';
import VATDetailView from '../VatForm';

const ReviewStep = ({
    vatPeriod,
    handleReviewVatPeriod,
    reviewVerification,
    handleDeleteVerification,
    operationInProgress
}) => {

    return (
        <div className="step-container">
            <style>{`
                .verification-status-card {
                    background: #f8fafc;
                    border: 1px solid #e2e8f0;
                    border-radius: 8px;
                    padding: 1rem;
                    margin-top: 1rem;
                }
                .verification-status-card .btn-sm {
                    padding: 0.375rem 0.75rem;
                    font-size: 0.875rem;
                }
            `}</style>

            <div className="step-header">
                <div className="d-flex align-items-center">
                    <div
                        className="rounded-circle d-flex align-items-center justify-content-center me-3"
                        style={{
                            width: '48px',
                            height: '48px',
                            backgroundColor: '#3b82f6',
                            color: 'white'
                        }}
                    >
                        <Eye size={24} />
                    </div>
                    <div>
                        <h3 className="mb-1">Granska Momsrapporten</h3>
                        <p className="text-muted mb-0">Kontrollera att uppgifterna är korrekta innan du fortsätter</p>
                    </div>
                </div>
            </div>

            <div className="step-content">
                {vatPeriod ? (
                    <div className="mb-4">
                        <VATDetailView period={vatPeriod} />
                    </div>
                ) : (
                    <div className="d-flex align-items-center py-4">
                        <Spinner animation="border" size="sm" className="me-2" />
                        <span>Laddar momsuppgifter...</span>
                    </div>
                )}
            </div>

            <div className="step-actions">
                {reviewVerification ? (
                    <div className="verification-status-card">
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <CheckCircle size={20} className="text-success me-2" />
                                <div>
                                    <div className="fw-medium">Verifikat skapat</div>
                                    <div className="small text-muted">
                                        {reviewVerification.series}{reviewVerification.number}
                                    </div>
                                </div>
                            </div>
                            {vatPeriod?.state === 'open' && (
                                <div className="d-flex gap-2">
                                    <Button
                                        variant="outline-danger"
                                        size="sm"
                                        onClick={() => handleDeleteVerification(reviewVerification.verification_id, 'review')}
                                        disabled={operationInProgress}
                                    >
                                        <Trash2 size={14} className="me-1" />
                                        Ta bort
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="d-flex justify-content-center">
                            <Button
                                variant="primary"
                                size="sm"
                                onClick={handleReviewVatPeriod}
                                className="d-flex align-items-center px-4"
                                disabled={operationInProgress}
                            >
                                <Eye size={20} className="me-2" />
                                Skapa bokföringsförslag för momsrapport
                            </Button>
                        </div>
                        <div className="text-center mt-3 text-muted small">
                            Detta är valfritt. Om du redan har skapat bokföringen kan du hoppa över detta steg.
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ReviewStep;